export default __webpack_public_path__ + "static/media/read.d64928aa.svg";